function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1391.86 -430.313)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1407.016 431.828)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 33.344,
  height: 3.031
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1407.016 437.891)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15.156,
  height: 3.031
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1407.016 450.016)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 33.344,
  height: 3.031
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1407.016 456.078)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15.156,
  height: 3.031
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1391.86 430.313)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1397.922,442.438a6.063,6.063,0,1,1,6.063-6.063A6.069,6.069,0,0,1,1397.922,442.438Zm0-9.095a3.032,3.032,0,1,0,3.031,3.032A3.035,3.035,0,0,0,1397.922,433.343Z",
  transform: "translate(-1391.86 -430.313)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1391.86 448.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1397.922,458.75a6.063,6.063,0,1,1,6.063-6.062A6.069,6.069,0,0,1,1397.922,458.75Zm0-9.094a3.031,3.031,0,1,0,3.031,3.031A3.035,3.035,0,0,0,1397.922,449.657Z",
  transform: "translate(-1391.86 -446.625)"
})));

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.5,
    height: 30.312,
    viewBox: "0 0 48.5 30.312",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.4ee38087.svg";
export { ForwardRef as ReactComponent };